import { StatusTone } from '../Modules/Shared/Types/status-tone.type';

export enum DeviceState {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  REAPABLE = 'reapable',
  RETIRED = 'retired',
}

export const DEVICE_STATE_OPTIONS: readonly DeviceState[] = [
  DeviceState.ACTIVE,
  DeviceState.INACTIVE,
  DeviceState.REAPABLE,
  DeviceState.RETIRED,
];

export const DEVICE_STATE_LABEL: Readonly<Record<string, string>> = {
  [DeviceState.ACTIVE]: 'backoffice.enums.device_state.active',
  [DeviceState.INACTIVE]: 'backoffice.enums.device_state.inactive',
  [DeviceState.REAPABLE]: 'backoffice.enums.device_state.reapable',
  [DeviceState.RETIRED]: 'backoffice.enums.device_state.retired',
};

export const DEVICE_STATE_TONE: Readonly<Record<string, StatusTone>> = {
  [DeviceState.ACTIVE]: 'positive',
  [DeviceState.INACTIVE]: 'warning',
  [DeviceState.REAPABLE]: 'danger',
  [DeviceState.RETIRED]: 'neutral',
};
